import { Component, OnInit, Inject } from '@angular/core';
import { CampsService } from '../../../services/camps.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Camping } from '../../../models/camp';

@Component({
  selector: 'app-camping-details-dialog',
  templateUrl: './camping-details-dialog.component.html',
  styleUrls: ['./camping-details-dialog.component.css']
})
export class CampingDetailsDialogComponent implements OnInit {

  constructor(
    private campSvc: CampsService,
    public dialogRef: MatDialogRef<CampingDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Camping) { }

  ngOnInit(): void {

  }

  onDialogClose() {
    this.dialogRef.close(false);
  }
}
